import React from 'react';
import pluralize from 'pluralize';

interface RemoveUserSuccessProps {
  uniqUsersLength: number;
  uniqSpacesLength: number;
  parentClasses?: {
    bold?: string;
  };
}

const RemoveUserSuccess = ({
  parentClasses,
  uniqUsersLength,
  uniqSpacesLength,
}: RemoveUserSuccessProps) => (
  <span>
    You just removed{' '}
    <span className={parentClasses.bold}>
      {pluralize('user', uniqUsersLength, true)}
    </span>{' '}
    from{' '}
    <span className={parentClasses.bold}>
      {pluralize('space', uniqSpacesLength, true)}
    </span>
  </span>
);

export default RemoveUserSuccess;
